import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {FuseMediaWatcherService} from "../../../../@fuse/services/media-watcher";
import {Subject, takeUntil} from "rxjs";

@Component({
    selector: 'app-dialog-wrap',
    templateUrl: './dialog-wrap.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DialogWrapComponent implements OnInit, OnDestroy {

    @Input() data: DialogWrapI
    @Output() close$: EventEmitter<void> = new EventEmitter<void>();
    private isScreenSmall: boolean;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private _fuseMediaWatcherService: FuseMediaWatcherService
    ) {
    }

    ngOnInit() {
        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) => {
                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('sm');
            });
    }

    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

}
export interface DialogWrapI {
    close?: boolean;
    title?: string;
    message?: string;
    icon?: {
        name?: string;
        color?: 'primary' | 'accent' | 'warn' | 'basic' | 'info' | 'success' | 'warning' | 'error';
    };
}
